module.exports = __webpack_public_path__ + "img/DE00947.47f2577a.png";